import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import {
    FetchProductGroupsResponse,
    ProductGroupQuery,
    fetchProductGroups,
} from "../../../productGroup/productGroupApi"
import { ApiQueryAutocomplete } from "../../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ProductGroupItem } from "../../../productGroup/productGroupTypes"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../../merchants/merchantHooks"

const useStyles = makeStyles()((_theme) => ({
    input: {
        width: "16rem",
        backgroundColor: "white",
    },
}))

const transformData = (data: FetchProductGroupsResponse) => data?.productGroups || []

type ProductGroupSelectorProps = Readonly<{
    productGroupId: ProductGroupItem | null
    handleChange: (el: ProductGroupItem | null) => void
}>

export const ProductGroupSelector = memo(({ productGroupId, handleChange }: ProductGroupSelectorProps) => {
    const { classes } = useStyles()
    const { merchantId } = useMerchant()

    const {
        data: productGroups = [],
        isLoading,
        isError,
    } = useApiQuery(fetchProductGroups, {
        queryName: ProductGroupQuery.LIST,
        dependencies: {
            merchantId: merchantId,
        },
        select: transformData,
    })

    return (
        <>
            <LocalizedStrict id="product-create-group-field-label" attrs={{ label: true }}>
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={productGroups}
                    value={productGroupId}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) => handleChange(value)}
                    label="Product group"
                    slotProps={{
                        textField: { className: classes.input },
                        errorSelect: { className: classes.input },
                    }}
                />
            </LocalizedStrict>
        </>
    )
})
